import { render } from "./Atencion_DiagAten.vue?vue&type=template&id=e94673aa"
import script from "./Atencion_DiagAten.vue?vue&type=script&lang=js"
export * from "./Atencion_DiagAten.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Software\\Aplicaciones\\kiatros\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__